// extracted by mini-css-extract-plugin
export default {"landingContainer":"LandingPage_landingContainer__bqKre","aboutSection":"LandingPage_aboutSection__6exsG"};